// @core/api/endpoints/chat/edit_message.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EditMessageRequest,
  MessageResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Edit a message
 * Edits the content of an existing message. The message is marked as edited and the edit history is preserved.
 */
export async function EditMessage(
  conversation_id: string,
  message_id: string,
  data: EditMessageRequest,
  options?: RequestOptions
): Promise<MessageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.put<MessageResponse>(requestPath, data, requestOptions);
}
